import { SAVE_USER_SETTINGS } from "adapters/ehr.service";
import { store } from "../../redux/store";
import { EMPTY_PAYLOAD, LIMITS } from "./license_helper";
import { getFhirBasicSkeleton } from "./payload_helper";
import _ from "lodash";
import { activeStatus } from "screens/store/storeHelper";

export const isFeatureAvailable = (action) => {
  const freeTrial = store?.getState()?.license?.package?.license === "TRIAL";
  const licenseObj = store?.getState()?.license?.package;
  const planStatus = store?.getState()?.license?.plan_status;
  if (!freeTrial && (!planStatus || activeStatus.indexOf(planStatus) == -1)) {
    return false;
  }
  const license = licenseObj?.license;

  if (!license) {
    console.error("No License Found in Redux");
    throw new Error("No License Found in Redux");
  }

  const featureLimitNumber = LIMITS?.[license]?.[action];

  if (featureLimitNumber === Infinity) return true;

  if (getNumberOfActionsDone(action) >= featureLimitNumber) return false;

  return true;
};

const getNumberOfActionsDone = (resource) => {
  const numberOfTimesResourceIsUsed =
    store?.getState()?.license?.package?.payload;
  return numberOfTimesResourceIsUsed?.[resource];
};

export const updateLicense = async (module, incrementValue = 1) => {
  const auth = store?.getState()?.auth;
  const licenseObj1 = store?.getState()?.license?.package;
  const licenseObj = _.cloneDeep(licenseObj1);

  const tempLicensePayloadForFhirBasic = {
    payload: licenseObj?.payload,
    license: licenseObj?.license,
    resetCount:licenseObj?.resetCount || 0
  };
  tempLicensePayloadForFhirBasic.payload[module] += incrementValue;
  let payload = getFhirBasicSkeleton();
  payload.subject.reference = `Person/${auth?.personData?.id}`;
  payload.extension[0].valueString = JSON.stringify(
    tempLicensePayloadForFhirBasic
  );
  payload.id = licenseObj?.id;

  const response = await SAVE_USER_SETTINGS("PUT", payload);

  try {
    return {
      ...JSON.parse(response?.data?.extension?.[0]?.valueString),
      id: response?.data?.id,
    };
  } catch (e) {
    console.log(e);
  }
};

export const upgradeLicense = (licenseObj = { license: "", id: "" }) => {
  const auth = store?.getState()?.auth;
  const tempLicensePayloadForFhirBasic = {
    payload: EMPTY_PAYLOAD,
    license: licenseObj.license,
    resetCount:0
  };
  let payload = getFhirBasicSkeleton();
  payload.subject.reference = `Person/${auth?.personData?.id}`;
  payload.extension[0].valueString = JSON.stringify(
    tempLicensePayloadForFhirBasic
  );
  payload.id = licenseObj?.id;
  return SAVE_USER_SETTINGS("PUT", payload).then((response) => {
    try {
      const payload = {
        ...JSON.parse(response?.data?.extension?.[0]?.valueString),
        id: response?.data?.id,
      };
      return payload;
    } catch (error) {
      console.log(error);
    }
  });
};

export const parseLicenseFromSetting = (licenseSetting) => {
  try {
    const resource = licenseSetting?.data?.entry?.[0]?.resource;
    return {
      ...JSON.parse(resource?.extension?.[0]?.valueString),
      id: resource?.id,
    };
  } catch (error) {
    console.error("Error Parsing license JSON", error);
    return null;
  }
};
